import React from "react";
import { useLocation, useParams } from "react-router-dom";
import ReportDataSummary from "./components/ReportDataSummary";

const ViewAdvancedReport = () => {
  const { generateReportId } = useParams();
  const location = useLocation();

  const generatedReports = location.state?.generatedReports || [];
  const report = generatedReports.find(r => r.reportId === generateReportId);


  return <ReportDataSummary card={report} />;
};

export default ViewAdvancedReport;
